module.exports = __webpack_public_path__ + "static/media/RTG.40fd291c.png";